import { Fragment, memo } from 'react';

import clsx from 'clsx';

import { ReactComponent as LoaderIcon } from '@/assets/images/loader.svg?react';

import { Icon } from '../../icon';
import { type ButtonProps, ButtonSize, ButtonVariant } from '../types';
import { ButtonTimer } from './button-timer/ButtonTimer';

import s from './Button.module.scss';

export const Button = memo<ButtonProps>(
  ({
    className,
    contentClassName,

    icon,
    iconStyle,
    rightIcon,
    rightIconStyle,
    size = ButtonSize.l50,
    variant = ButtonVariant.primary,
    bubble,
    counter,

    media,
    disabled,
    shine,
    loading,

    timer,

    children,

    ...buttonProps
  }) => {
    const Wrapper = timer ? 'div' : Fragment;

    return (
      <Wrapper
        {...(timer
          ? {
              className: clsx(
                s['timer-wrapper'],
                s[size],
                s[variant],
                bubble && s.bubble,
                disabled && s.disabled
              ),
            }
          : {})}
      >
        {!!timer && <ButtonTimer {...timer} className={clsx(s.timer, timer.className)} />}
        <button
          className={clsx(
            s.container,
            s[size],
            s[variant],
            bubble && s.bubble,
            media && s.media,
            shine && s.shine,
            loading && s.loading,
            disabled && s.disabled,
            className
          )}
          disabled={disabled || loading}
          {...buttonProps}
        >
          {bubble && (
            <>
              <span className={s['glare-l']} />
              <span className={s['glare-r']} />
            </>
          )}
          <div className={clsx(s.content, contentClassName)}>
            {!!icon && <Icon icon={icon} className={s.icon} style={iconStyle} />}
            <div className={s['content-inner']}>{children}</div>
            {counter !== undefined && counter !== null && counter !== '' && (
              <span className={s.counter}>{counter}</span>
            )}
            {!!rightIcon && (
              <Icon
                icon={rightIcon}
                className={clsx(s.icon, s['right-icon'])}
                style={rightIconStyle}
              />
            )}
          </div>
          {loading && (
            <div className={s.spinner}>
              <LoaderIcon className={s['spinner-icon']} />
            </div>
          )}
        </button>
      </Wrapper>
    );
  }
);

Button.displayName = 'Button';
